var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "Element",
      class:
        "BlockPaging " +
        this.ClassName +
        " " +
        this.m_TouchingClassName +
        " " +
        this.m_UniqueClassName,
      attrs: {
        ControlInstance: "true",
        Designer: "BlockPagingDesigner",
        contenteditable: "false",
        ContentEditable: "false",
        ControlId: _vm.ControlId
      },
      on: { mouseover: _vm.OnMouseOver, mouseleave: _vm.OnMouseLeave }
    },
    [
      _c("A", {
        class: {
          "PagingButton Previous": true,
          Disabled: this.PlayMode == "Normal" && this.m_PlayPageIndex <= 0
        },
        staticStyle: { visibility: "visible" },
        on: { click: _vm.OnMoveToPreviousButtonClick }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "BlockItemListContainer",
          staticClass: "BlockItemListContainer"
        },
        [
          _c(
            "div",
            { ref: "BlockItemList", staticClass: "BlockItemList" },
            _vm._l(_vm.PlayBlockItemList, function(blockItem) {
              return _c("RichEditor", {
                staticClass: "BlockItem",
                class: { Focus: blockItem.SourceIndex == _vm.ItemIndex },
                attrs: { Editable: false },
                on: {
                  click: function($event) {
                    return _vm.OnBannerItemClick(blockItem)
                  }
                },
                model: {
                  value: blockItem.RichHtml,
                  callback: function($$v) {
                    _vm.$set(blockItem, "RichHtml", $$v)
                  },
                  expression: "blockItem.RichHtml"
                }
              })
            }),
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "Pagination" }, [
        _c(
          "div",
          _vm._l(this.blockitemlist, function(item, index) {
            return _c(
              "div",
              {
                staticClass: "Item",
                class: { Current: _vm.m_PageIndex == index },
                on: {
                  click: function($event) {
                    return _vm.MoveToSourcePage(index)
                  }
                }
              },
              [
                _c("div", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(index + 1) +
                      "\n                "
                  )
                ])
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("A", {
        class: {
          "PagingButton Next": true,
          Disabled:
            this.PlayMode == "Normal" &&
            this.m_PlayPageIndex >= this.m_PlayPageCount - 1
        },
        staticStyle: { visibility: "visible" },
        on: { click: _vm.OnMoveToNextButtonClick }
      }),
      _vm._v(" "),
      _c("style", { key: _vm.Key, tag: "component" }, [
        _vm._v(
          "\n        .BlockPaging." +
            _vm._s(this.m_UniqueClassName) +
            " > .BlockItemListContainer > .BlockItemList > .BlockItem {\n        width : " +
            _vm._s(this.m_ItemWidth) +
            " ;\n        }\n\n\n        .BlockPaging." +
            _vm._s(this.m_UniqueClassName) +
            " > .BlockItemListContainer > .BlockItemList {\n        width : " +
            _vm._s(_vm.m_BlockItemListWidth) +
            " ;\n        }\n\n\n        @media screen and (max-width:860px){\n        .BlockPaging." +
            _vm._s(this.m_UniqueClassName) +
            " > .BlockItemListContainer > .BlockItemList {\n        width : " +
            _vm._s(_vm.m_BlockItemList860Width) +
            " ;\n        }\n        }\n\n        @media screen and (max-width:660px){\n        .BlockPaging." +
            _vm._s(this.m_UniqueClassName) +
            " > .BlockItemListContainer > .BlockItemList {\n        width : " +
            _vm._s(_vm.m_BlockItemList660Width) +
            " ;\n        }\n        }\n\n        @media screen and (max-width:440px){\n        .BlockPaging." +
            _vm._s(this.m_UniqueClassName) +
            " > .BlockItemListContainer > .BlockItemList {\n        width : " +
            _vm._s(_vm.m_BlockItemList440Width) +
            " ;\n        }\n        }\n    "
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }